import React, { Component } from "react";
import queryString from "query-string";

import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Form, Progress, Row } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MiniWidget from "../../../../components/MiniWidget/index";
import QualityMediaSourceCharts from "../components/QualityMediaSourceCharts";
import {
  getQualityMediaSource,
  getQualityWidgets,
  setNonCahortReportDate,
  getQualityFilters,
  setQualityFilters,
  setQualityEvents,
  setQualityTable,
  RequestDataUpdate,
  setQualityMediaSource,
  getReportEventsStats
} from "../../../../store/reporting/actions";
import { getEvents, setEvents } from "../../../../store/events/actions";
import { getCampaignSourcesList } from "../../../../store/campaigns/sources/actions";
import { getApplications } from "../../../../store/apps/actions";
import ReactTableForm from "../../../../components/Common/ReactTableForm";
import {
  getCurrentDay,
  getSelectedMonthAgo,
  formatNumbersForTable,
  formattedObjectsForFilter,
} from "../../../../helpers/utils";
import DynamicFormToFilter from "./../../../../components/forms/DynamicFormToFilter";
import CustomBreadcrumbs from "./../../../../components/Common/CustomBreadcrumbs";
import CustomCurrencySelect from "../../../../components/CustomCurrencySelect/CustomCurrencySelect";
import DefaultMultipleSelect from "../../../../components/DefaultMultipleSelect/DefaultMultipleSelect";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';
import ProgressDataBudget from "./ProgressDataBudget";

class QualityMediaSource extends Component {
  constructor(props) {
    super(props);
    this.styleNumbers = {
      textAlign: "center",
      width: "auto",
      verticalAlign: "middle",
    };
    this.mediaSourceColumns = [
      {
        Header: "Media Source",
        src: "media_source",
        style: {
          ...this.styleNumbers,
          minWidth: 130,
        },
        accessor: row => (
          <Link
            to={{
              pathname: `/quality-report/${this.props.match.params.app_id}/${row.media_source}`,
              state: {
                app_name: this.state.app_name,
              },
            }}
          >
            {row.media_source}
          </Link>
        ),
        isSorted: true,
      },
      {
        Header: "Payment",
        src: "payment",
        accessor: row => formatNumbersForTable(row.payment),
        isSorted: true,
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
      },
      {
        Header: "Spend",
        src: "spend",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.spend),
        isSorted: true,
      },
      {
        Header: "Profit",
        src: "profit",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.profit),
        isSorted: true,
      },
      {
        Header: "Cashback",
        src: "cashback",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.cashback),
        isSorted: true,
      },
      {
        Header: "Clicks",
        src: "clicks",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.clicks),
        isSorted: true,
      },
      {
        Header: "Impressions",
        src: "shows",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.shows),
        isSorted: true,
      },
      {
        Header: "Installs",
        src: "installs",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.installs),
        isSorted: true,
      },
      {
        Header: "CTR",
        src: "CTR",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.CTR) + "%",
        isSorted: true,
      },
      {
        Header: "CPC",
        src: "CPC",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.CPC),
        isSorted: true,
      },
      {
        Header: "CPM",
        src: "CPM",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.CPM),
        isSorted: true,
      },
      {
        Header: "CR",
        src: "CR",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row => formatNumbersForTable(row.CR),
        isSorted: true,
      },
      {
        Header: "CPI",
        src: "CPI_post_click_plus_post_view",
        style: {
          ...this.styleNumbers,
          minWidth: 110,
        },
        accessor: row =>
          formatNumbersForTable(row.CPI_post_click_plus_post_view),
        isSorted: true,
      },
    ];
    this.state = {
      reports: [
        {
          icon: "mdi mdi-eye-check-outline",
          title: "Impressions",
          value: 0,
          badgeValue: `Undefined`,
          color: "danger",
          desc: "From previous period",
          type: "WITH_DIFFERENCE",
        },
        {
          icon: "mdi mdi-cursor-default-click-outline",
          title: "Clicks",
          value: 0,
          badgeValue: `Undefined`,
          color: "danger",
          desc: "From previous period",
          type: "WITH_DIFFERENCE",
        },
        {
          icon: "mdi mdi-contactless-payment-circle-outline",
          title: "Payment",
          value: 0,
        },
        {
          icon: "mdi mdi-cash-100",
          title: "Spend",
          value: 0,
        },
        {
          icon: "mdi mdi-cash-plus",
          title: "Profit",
          value: 0,
        },
      ],
      clients: [],
      columns: [],
      currency: [
        { label: "USD", value: "USD" },
        { label: "EUR", value: "EUR" },
      ],
      selectedEvents: [],
      app_name: undefined,
    };
  }

  componentDidMount() {
    const app_id = this.props.match.params.app_id;
    const location = this.props.history.location;

    this.setState({ columns: this.mediaSourceColumns });

    if (this.props.history.location.state == undefined) {
      this.props.getApplications(this.props.apps);
    }

    if (app_id) {
      let parsedSearch = queryString.parse(this.props.history.location.search);
      let data = {};
      data.start_date = parsedSearch.start_date || getSelectedMonthAgo(2);
      data.end_date = parsedSearch.end_date || getCurrentDay();
      data.currency = parsedSearch.currency || this.state.currency[0].value;
      data.app_id = app_id;

      if (this.props.nonCahortDate === null) {
        let formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            start_date: data.start_date,
            end_date: data.end_date,
            currency: data.currency,
          })
        );

        location.search = formQueryString;
        this.props.history.replace(location);

        this.props.setNonCahortReportDate(data);
        // this.props.getQualityMediaSource(data);
        this.props.getQualityWidgets(data);
        this.props.getQualityFilters(data);
        this.setState({
          app_name: this.props.history.location.state?.app_name,
        });

      } else {
        let parsedSearch = queryString.parse(
          this.props.history.location.search
        );

        let cahortDate = this.props.nonCahortDate;
        let updateCahort = {};

        updateCahort.app_id = app_id;
        updateCahort.start_date = cahortDate.start_date;
        updateCahort.end_date = cahortDate.end_date;
        updateCahort.currency = cahortDate.currency;

        let parsedObject = {
          start_date: updateCahort.start_date,
          end_date: updateCahort.end_date,
          currency: updateCahort.currency,
        };

        let formQueryString = "";

        if (cahortDate?.mediabuyers) {
          updateCahort.mediabuyers = cahortDate.mediabuyers;
          formQueryString = queryString.stringify(
            Object.assign(parsedSearch, {
              ...parsedObject,
              mediabuyers: updateCahort.mediabuyers.split(","),
            })
          );
        } else {
          formQueryString = queryString.stringify(
            Object.assign(parsedSearch, {
              ...parsedObject,
            })
          );
        }

        if (parsedSearch?.event_id) {
          if (Array.isArray(parsedSearch?.event_id)) {
            this.eventListener([parsedSearch?.event_id.map(i => {
              return {
                label: i,
              }
            })])
          } else {
            this.eventListener([{ label: parsedSearch?.event_id }])
          }
        }

        location.search = formQueryString;
        this.props.history.replace(location);
        this.props.getQualityFilters(updateCahort);
        // this.props.getQualityMediaSource(updateCahort);2
        this.props.getQualityWidgets(updateCahort);
        this.setState({
          app_name: this.props.history.location.state?.app_name,
        });
      }

      this.props.getEvents({
        tracker_app_id: app_id,
      });
      if (this.props.quality_table === null) {
        this.props.setQualityTable(this.mediaSourceColumns);
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.mediaSourceStats !== this.props.mediaSourceStats) {
      this.props.events.length <= 0 &&
        this.props.getEvents({
          tracker_app_id: this.props.match.params.app_id,
        });
    }

    if (prevState.app_name !== this.state.app_name) {
      this.setState({
        columns: this.mediaSourceColumns,
        app_name: this.state.app_name,
      });
      this.props.setQualityTable(this.mediaSourceColumns);
      this.props.getCampaignSourcesList({
        ...this.props.mediaSources,
        sizePerPage: 50,
      });
    }
    if (prevProps.apps !== this.props.apps) {
      let currentSearch = queryString.parse(this.props.history.location.search);
      let appName = this.props.apps.results.find(
        app => app.app_id === this.props.match.params.app_id
      ).name;
      this.props.history.location.search = queryString.stringify(currentSearch);
      this.props.history.replace(this.props.history.location);
      this.setState({ app_name: appName });
    }
    if (prevProps.quality_widgets !== this.props.quality_widgets) {
      const widgets = this.props.quality_widgets[0];
      this.setState({
        reports: [
          {
            icon: "mdi mdi-eye-check-outline",
            title: "Impressions",
            value: widgets?.shows_sum || 0,
            badgeValue:
              widgets?.shows_change > 0
                ? `+ ${widgets?.shows_change}%`
                : widgets?.shows_change !== undefined
                  ? `- ${widgets?.shows_change}%`
                  : `Undefined`,
            color: widgets?.shows_change > 0 ? "success" : "danger",
            desc: "From previous period",
            type: "WITH_DIFFERENCE",
          },
          {
            icon: "mdi mdi-cursor-default-click-outline",
            title: "Clicks",
            value: widgets?.clicks_sum || 0,
            badgeValue:
              widgets?.clicks_change > 0
                ? `+ ${widgets?.clicks_change}%`
                : widgets?.clicks_change !== undefined
                  ? `- ${widgets?.clicks_change}%`
                  : `Undefined`,
            color: widgets?.clicks_change > 0 ? "success" : "danger",
            desc: "From previous period",
            type: "WITH_DIFFERENCE",
          },
          {
            icon: "mdi mdi-contactless-payment-circle-outline",
            title: "Payment",
            value: this.props.quality_widgets[0]?.payment_sum || 0,
          },
          {
            icon: "mdi mdi-cash-100",
            title: "Spend",
            value: this.props.quality_widgets[0]?.spend_sum || 0,
          },
          {
            icon: "mdi mdi-cash-plus",
            title: "Profit",
            value: this.props.quality_widgets[0]?.profit_sum || 0,
          },
        ],
      });
    }
    if (this.props.quality_events !== prevProps.quality_events) {
      let updated_events = this.mediaSourceColumns.concat(
        this.props.quality_events
      );
      this.props.setQualityTable(updated_events);
    }
  }

  componentWillUnmount() {
    this.props.setQualityEvents([]);
    this.props.setQualityTable(null);
    this.props.setQualityFilters({});
    this.props.setQualityMediaSource([])
    this.props.setEvents([]);
    this.setState({ selectedEvents: [] })
  }

  onTableChange = data => {
    this.props.nonCahortDate.ordering = data?.ordering;
    this.props.getQualityMediaSource(this.props.nonCahortDate, {
      start_date: this.props.nonCahortDate.start_date,
      end_date: this.props.nonCahortDate.end_date,
      grouping: 'media_source',
      currency: this.props.nonCahortDate?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: this.props.match.params.app_id,
    });
  };

  onFiltersChange = (type, filter, filter_type) => {
    const prevSearch = queryString.parse(this.props.history.location.search);

    const data = this.props.nonCahortDate;

    let check =
      data.start_date === filter.start_date &&
      data.end_date === filter.end_date;

    data.start_date = filter.start_date;
    data.end_date = filter.end_date;
    data.app_id = this.props.match.params.app_id;

    switch (filter_type) {
      case "media_source":
        data.media_source = filter.media_source.join().toLowerCase();
        break;
      case "mediabuyers":
        data.mediabuyers = filter.mediabuyers.join(",");
        break;
    }

    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, filter)
    );

    if (!check || filter_type !== undefined) {
      type === "date" && this.props.getQualityWidgets(data);

      this.props.getQualityMediaSource(data, {
        start_date: data.start_date,
        end_date: data.end_date,
        grouping: 'media_source',
        currency: data?.currency || "USD",
        event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
        tracker_app_id: data.app_id,
      });

      // this.props.getQualityMediaSource(data);
      this.props.setNonCahortReportDate(data);
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }
  };

  onCurrencyChange = data => {
    const updateData = this.props.nonCahortDate;
    let prevHistory = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.nonCahortDate.start_date,
        end_date: this.props.nonCahortDate.end_date,
        currency: data.value,
      })
    );
    updateData.currency = data.value;
    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.setNonCahortReportDate(updateData);
    this.props.getQualityWidgets(updateData);
    this.props.getQualityMediaSource(updateData, {
      start_date: updateData.start_date,
      end_date: updateData.end_date,
      grouping: 'media_source',
      currency: updateData?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: this.props.match.params.app_id,
    });
  };

  eventListener = data => {
    let filteredData = [];
    let prevHistory = queryString.parse(this.props.history.location.search);
    let media_source = []
    let params = {};
    let sourceCurrentData = this.props.mediaSourceStats.results;
    let cahortDate = this.props.nonCahortDate;

    if (sourceCurrentData.length > 0) {
      sourceCurrentData.map(i => {
        media_source.push(i?.media_source)
      })

      params = {
        media_source: media_source.join(','),
        start_date: cahortDate?.start_date,
        end_date: cahortDate?.end_date,
        grouping: 'media_source',
        currency: cahortDate?.currency || "USD",
        event_name: [data.map(i => i.label)].join(','),
        tracker_app_id: this.props.match.params.app_id,
      }
      this.props.getReportEventsStats(params);
    }

    data.map(i => filteredData.push(i.value));

    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.nonCahortDate.start_date,
        end_date: this.props.nonCahortDate.end_date,
        event_id: filteredData,
      })
    );

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.setState({
      selectedEvents: data,
    })
    // this.props.setQualityEvents(events);
  };

  render() {
    const widgetData = this.props.quality_widgets;

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title={`${this.state?.app_name || 'Application'} | Mobihunter`} />

          <Container fluid>
            {this.state.app_name !== undefined && (
              <>
                <Breadcrumbs
                  title="Quality Report"
                  breadcrumbItem={this.state.app_name}
                  link="/quality-report"
                  className="fade-in-custom-animate"
                />
                <DynamicFormToFilter
                  onFiltersChange={this.onFiltersChange}
                  filtersFields={[
                    {
                      filterData: formattedObjectsForFilter(
                        this.props.quality_filters,
                        "media_sources",
                        "label"
                      ),
                      plug: "Media source...",
                      filterType: "media_source",
                    },
                    // {
                    //   filterData: formattedObjectsForFilter(
                    //     this.props.quality_filters,
                    //     "media_buyers"
                    //   ),
                    //   plug: "Media buyers...",
                    //   filterType: "mediabuyers",
                    // },
                  ]}
                  selectedDate={
                    Object.keys(
                      queryString.parse(this.props.history.location.search)
                    ).length == 0
                      ? this.props.nonCahortDate
                      : queryString.parse(this.props.history.location.search)
                  }
                  filtered_by={["media_source", "mediabuyers"]}
                  filtered_params={queryString.parse(
                    this.props.history.location.search
                  )}
                />

                <ProgressDataBudget widgetData={widgetData} nonCahortDate={this.props.nonCahortDate} />

                <Col xl={12} className="fade-in-custom-animate-1s">
                  <Row>
                    <MiniWidget
                      data={this.state.reports}
                      loading={this.props.widget_loader}
                    />
                  </Row>
                </Col>
                <Row>
                  <Col className="col-12">
                    <Card>
                      <CardBody>
                        <Row className="justify-content-between align-middle">
                          <Col xs={6}>
                            <h4 className="mb-2">All media sources</h4>
                            <CustomBreadcrumbs breadcrumbItem={[]} />
                          </Col>
                          <Col xs={6} className="align-content-end">
                            <Form className="row align-items-center float-end ms-1">
                              <div className="col-sm-auto">
                                <CustomCurrencySelect
                                  options={this.state.currency}
                                  onChange={this.onCurrencyChange}
                                  defaultValue={queryString.parse(
                                    this.props.history.location.search
                                  )}
                                />
                              </div>
                            </Form>
                            <Form className="row align-items-center float-end">
                              <div className="col-sm-4">
                                <DefaultMultipleSelect
                                  options={this.props.events.map(
                                    ({ value, label, checked }) => ({
                                      key: label,
                                      text: label,
                                      checked,
                                    })
                                  )}
                                  filtered_params={queryString.parse(
                                    this.props.history.location.search
                                  )}
                                  onChange={this.eventListener}
                                  filtered_by="event_id"
                                  plug="Select events.."
                                  search
                                />
                              </div>
                            </Form>
                          </Col>
                        </Row>
                        {this.props.quality_table !== null && (
                          <ReactTableForm
                            loading={this.props.source_loader}
                            columns={this.props.quality_table}
                            data={this.props.mediaSourceStats}
                            onTableChange={this.onTableChange}
                            firstIsSticky
                          />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
            <QualityMediaSourceCharts
              data={this.props.mediaSourceStats}
              loading={this.props.source_loader}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

QualityMediaSource.propTypes = {
  history: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      campaign_id: PropTypes.node,
      app_id: PropTypes.node,
    }).isRequired,
  }).isRequired,
  apps: PropTypes.any,
  loading: PropTypes.bool,
  apps_loading: PropTypes.bool,
  mediaSourceStats: PropTypes.any,
  quality_widgets: PropTypes.any,
  nonCahortDate: PropTypes.any,
  mediaSources: PropTypes.any,
  quality_events: PropTypes.any,
  quality_table: PropTypes.any,
  widget_loader: PropTypes.bool,
  source_loader: PropTypes.bool,
  getQualityWidgets: PropTypes.func.isRequired,
  getQualityMediaSource: PropTypes.func,
  setNonCahortReportDate: PropTypes.func.isRequired,
  getApplications: PropTypes.func.isRequired,
  getCampaignSourcesList: PropTypes.func.isRequired,
  getQualityFilters: PropTypes.func.isRequired,
  quality_filters: PropTypes.object.isRequired,
  setQualityFilters: PropTypes.func.isRequired,
  setQualityEvents: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  setQualityTable: PropTypes.func.isRequired,
  RequestDataUpdate: PropTypes.func.isRequired,
  setQualityMediaSource: PropTypes.func.isRequired,
  getReportEventsStats: PropTypes.func.isRequired,
  setEvents: PropTypes.func.isRequired,
  events: PropTypes.any,
};

const mapStateToProps = state => ({
  apps: state.Apps.data,
  apps_loading: state.Apps.loading,
  events: state.Events.events,
  widget_loader: state.Reporting.widget_loader,
  loading: state.Reporting.loading,
  quality_filters: state.Reporting.quality_filters,
  quality_widgets: state.Reporting.quality_widgets,
  mediaSourceStats: state.Reporting.mediaSourceStats,
  nonCahortDate: state.Reporting.nonCahortDate,
  mediaSources: state.CampaignSourceList.data,
  source_loader: state.Reporting.media_source_loader,
  quality_events: state.Reporting.quality_events,
  quality_table: state.Reporting.quality_table,
});

export default connect(mapStateToProps, {
  getQualityMediaSource,
  setQualityMediaSource,
  getQualityWidgets,
  setNonCahortReportDate,
  getApplications,
  getCampaignSourcesList,
  getQualityFilters,
  setQualityFilters,
  setQualityEvents,
  getEvents,
  setQualityTable,
  RequestDataUpdate,
  getReportEventsStats,
  setEvents
})(QualityMediaSource);
